import { Features } from '@alsid/common'
import { rbacCapabilityCheckAllOf } from '@libs/rbac/functions'
import { accessByFeatureFlag, readLandingPage } from '@libs/rbac/permissions'

export const canAccessToLandingPage = rbacCapabilityCheckAllOf(
  readLandingPage(),
  accessByFeatureFlag(Features.KAPTEYN_LANDING_PAGE_ENABLEMENT)()
)
